module.exports = __webpack_public_path__ + "img/52114145_L.7075d59f.png";